export function createActivityQuery(excludeAudio = false) {
  return `
    query Activity($activityIds: [String]!) {
      getActivity(activityId: $activityIds, filter: {equatedScores: true}) {
        activityId
        type
        studentId
        displayStatus
        story {
          storyId
          title
          tags
          chapters {
            phrases
            items {
              interactions {
                ids
                reason
                standardMapping {
                  standardSet
                  standardId
                  amiraSkillId
                  description
                  reason
                }
              }
            }
          }
        }
        ${!excludeAudio ? `
        audio {
          url
        }` : ''}
        createdAt
        updatedAt
        score
        scores{
          wcpmScore
          equatedWCPM
          armScore
          areaScore
          comprehensionScore
        }
        scoreEstimates{
          ARM_estimate
        }
        status
        errors
        interventionWords
        flagging {
          triggered
        }
        timeRead
        timeReadClipped
        mispronunciations
        skips
        selfCorrections
        children {
          activityId
          type
          status
          displayStatus
          errors
          scores {
            predWcpm
            armScore
          }
        }
        comprehensionDialog {
          phraseIndex
          stage
          mode
          prompt
          responseSummary
          studentResponse
          ${!excludeAudio ? `
          audio {
            url
          }` : ''}
          feedback
          score
        }
      }
    }
  `;
}